import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_PREVENTIVE_MAINTENANCE_SUCCESS,
  FETCH_PREVENTIVE_MAINTENANCE_LAST_PROCESSED_SUCCESS,
  FETCH_PREVENTIVE_MAINTENANCE_SUCCESS,
  GET_PREVENTIVE_MAINTENANCE_SUCCESS,
  PREVENTIVE_MAINTENANCE_PROCESS_SUCCESS,
  PREVENTIVE_MAINTENANCE_TASK_UPDATE_SUCCESS,
  SAVE_PREVENTIVE_MAINTENANCE_QUERY
} from "../../constants/ActionTypes";
import axios from 'util/Api'
import {fetchError, fetchFilter, fetchStart, fetchSuccess} from "./Common";
import {arrayToCSV, downloadCSV} from "../../util/methods";
import {message} from "antd";
import Swal from "sweetalert2";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_PREVENTIVE_MAINTENANCE_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_PREVENTIVE_MAINTENANCE_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_PREVENTIVE_MAINTENANCE_SUCCESS,
    data
  };
};

export const taskUpdateSuccess = ({data}) => {
  return {
    type: PREVENTIVE_MAINTENANCE_TASK_UPDATE_SUCCESS,
    data
  };
};

export const updateProcessSuccess = ({data}) => {
  return {
    type: PREVENTIVE_MAINTENANCE_PROCESS_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_PREVENTIVE_MAINTENANCE_SUCCESS,
    data
  };
};

export const fetchLastProcessedResourceSuccess = ({data}) => {
  return {
    type: FETCH_PREVENTIVE_MAINTENANCE_LAST_PROCESSED_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {preventiveMaintenance} = store.getState();
      const {query} = preventiveMaintenance;
      // console.log(query)
      const response = await axios.get(`/preventive-maintenance?${generateQueryString(query)}`);
      // console.log(response)
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {preventiveMaintenance} = store.getState();
      const {query} = preventiveMaintenance;
      const response = await axios.get(`/preventive-maintenance/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/preventive-maintenance`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }
      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/pmchecklist');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  // console.log(payload, id);
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.put(`/preventive-maintenance/task/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }

      dispatch(fetchSuccess());
      const {pm, isCompleted} = response.data;
      if (pm) {
        try {
          const tasks = pm.tasks || [];
          const updatedTask = tasks.filter(task => task.task._id === payload.task);
          // console.log(updatedTask);
          message.success(`${updatedTask && updatedTask.length && updatedTask[0].task.taskCode || '1'} Task Updated!`)
        } catch (e) {
          message.success(`1 Task Updated!`)
        }
      }
      dispatch(fetchResourceSuccess({data: response.data}));
      // dispatch(taskUpdateSuccess({data: response.data}));
      // dispatch(getUser());
      // history.push('/preventive-maintenance/process/' + id);
      // dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/preventive-maintenance/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchLastProcessedResource = (asset, si, currentId = null) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let url = `/preventive-maintenance/get-last-processed/${asset}/${si}`;
      if (currentId)
        url = `/preventive-maintenance/get-last-processed/${asset}/${si}/${currentId}`;
      const response = await axios.get(url);
      dispatch(fetchSuccess());
      dispatch(fetchLastProcessedResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/preventive-maintenance/${id}`);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const processList = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      const documentData = [];
      payload.documents && payload.documents.length && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;
        documentData.push(data)
      });
      formData.append('documentData', JSON.stringify(documentData));
      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return
        }
        formData.append(key, payload[key]);
      });

      const response = await axios.put(`/preventive-maintenance/process/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      if (response.data === true) {
        message.success(`PM Schedule successfully processed!`);
      }
      dispatch(fetchSuccess());
      history.push("/pmchecklist");
      dispatch(updateProcessSuccess({data: response.data}));
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
}

